import { memo } from 'react';
import { HelpCircle } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function AssumptionNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={HelpCircle} nodeType="assumption" />;
}

export const AssumptionNode = memo(AssumptionNodeComponent);
